import { render, staticRenderFns } from "./productCenter.vue?vue&type=template&id=1f3ef97e&scoped=true"
import script from "./productCenter.vue?vue&type=script&lang=ts"
export * from "./productCenter.vue?vue&type=script&lang=ts"
import style0 from "./productCenter.vue?vue&type=style&index=0&id=1f3ef97e&prod&lang=scss&scoped=true"
import style1 from "./productCenter.vue?vue&type=style&index=1&id=1f3ef97e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3ef97e",
  null
  
)

export default component.exports